const ROUTES = {
  BOOKING: { path: '/bookings' },
  PROFILE: { path: '/profile' },
  PACKAGES: { path: '/packages' },
  ADD_PACKAGES: { path: '/add-packages' },
  EDIT_PACKAGES: { path: '/edit-packages' },
  LOGIN: { path: '/login' },
};

const routes = ({ pathname = '', isLoggedIn = false, common = [] }) => {
  let basePathName = '';
  let path = '';

  if (!isLoggedIn) {
    basePathName = ROUTES.LOGIN.path;
  } else {
    basePathName = ROUTES.BOOKING.path;
  }

  const loggedInRoutes = [
    ROUTES.BOOKING.path,
    ROUTES.PROFILE.path,
    ROUTES.PACKAGES.path,
    ROUTES.ADD_PACKAGES.path,
    ROUTES.EDIT_PACKAGES.path,
  ];
  const loggedOutRoutes = [ROUTES.LOGIN.path];

  if (pathname === '/') {
    path = basePathName;
  } else {
    path = common.includes(pathname)
      ? pathname
      : !isLoggedIn &&
        !pathname.endsWith('/login') &&
        loggedInRoutes.includes(pathname)
      ? `${pathname}/login`
      : isLoggedIn && pathname.endsWith('/login')
      ? pathname.substring(0, pathname.lastIndexOf('/'))
      : basePathName;
  }

  return {
    loggedInRoutes,
    loggedOutRoutes,
    path,
  };
};

export { ROUTES };

export default routes;
